import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class MaterialDeliveriesDbTableDefinition extends DbTableDefinition {
  tableName = 'materialdelivery';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
      databag LONGTEXT,
      label TEXT,
      carid BIGINT(20),
      carlabel TEXT,
      description TEXT,
      deliverydate DOUBLE
    );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    this.updateStatements.set(18, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
